import api from './api';

export const seasonService = {
  async getSeasons(params = {}) {
    try {
      const response = await api.get('/seasons', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch seasons');
    }
  },

  async getSeason(id) {
    try {
      const response = await api.get(`/seasons/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch season');
    }
  },

  async createSeason(data) {
    try {
      const response = await api.post('/seasons', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create season');
    }
  },

  async updateSeason(id, data) {
    try {
      const response = await api.put(`/seasons/${id}`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update season');
    }
  },

  async deleteSeason(id) {
    try {
      const response = await api.delete(`/seasons/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete season');
    }
  },

  async searchSeasons(query) {
    try {
      const response = await api.get('/seasons', { 
        params: { search: query }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to search seasons');
    }
  },

  async getSeasonsByType(type) {
    try {
      const response = await api.get('/seasons', { 
        params: { type }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch seasons by type');
    }
  },

  async getSeasonsByStatus(status) {
    try {
      const response = await api.get('/seasons', { 
        params: { status }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch seasons by status');
    }
  }
};
